import React from 'react';
import { useRequest,useUpdateEffect } from 'ahooks';

type useGetDataOptions<Params, PageInfo, Response> = {
  defaultPageInfo?: { page: number; pageSize: number; };
  getData(paramsAndPageInfo: Params & PageInfo): Promise<any>;
  defaultParams?: Params;
};

export type PageInfoBase = { page: number; pageSize: number; }

export type UseGetDataResultReturnType<Params, PageInfo extends PageInfoBase = PageInfoBase> = {
  params:Params,
  pageInfo:PageInfo,
  loading:boolean,
  setParams(params:Params, notRunAsync?:boolean):void,
  setPageInfo(pageInfo:PageInfo):void,
  setParamsAndPageInfo(params:Params,pageInfo:PageInfo):void,
}

export type defaultPageInfo =  { page: number; pageSize: number }

export const useGetData = <
  Params extends {},
  PageInfo extends defaultPageInfo = defaultPageInfo,
  Response = any,
>(options: useGetDataOptions<Params, PageInfo, Response>,):UseGetDataResultReturnType<Params,PageInfo> => {
  const { defaultPageInfo, getData, defaultParams = {} } = options || {};
  const [params, setParams] = React.useState<Params>(defaultParams as Params);
  const [pageInfo, setPageInfo] = React.useState<PageInfo>(
    (defaultPageInfo || { page: 1, pageSize: 10 }) as PageInfo,
  );
  // const finishRef = React.useRef<Function>()
  const { loading, runAsync } = useRequest(getData,{manual:true})
  // useUpdateEffect(()=>{
  //    async function fn(){
  //       await runAsync({ ...params, ...pageInfo });
  //       finishRef.current && finishRef.current()
  //       finishRef.current = undefined
  //    }
  //    fn()
  // },[params,pageInfo])
  return {
    params,
    pageInfo,
    loading,
    setParams: async (params: Params, notRunAsync?:boolean) => {
      setParams(params);
      const newPageInfo = { ...pageInfo };
      newPageInfo.page = 1;
      setPageInfo(newPageInfo);
      // 支持仅仅缓存参数，而不执行请求
      if (notRunAsync) {
        return Promise.resolve(undefined);
      }
      return runAsync({ ...params, ...newPageInfo });
    },
    setPageInfo: async  (pageInfo: PageInfo) => {
      setPageInfo(pageInfo);
      return runAsync({ ...params, ...pageInfo });
    },
    setParamsAndPageInfo:async (params:Params,pageInfo: PageInfo)=>{
      setParams(params);
      setPageInfo(pageInfo);
      return runAsync({ ...params, ...pageInfo });
    }
  };
};
